import '../Styles/AdminDropdown.css'
const AdminDropdown = ({ selectedCompany, setSelectedCompany, allCompanies}) => {
    console.log('Companies in AdminDropdown:', allCompanies);
    return (
        <div className="adminDropdown-container">
        <label htmlFor="year-select" className="year-select-label">Vælg firma: </label>
        <select className="form-select"
                value={selectedCompany}
                onChange={(event) => setSelectedCompany(event.target.value)}>
            <option value="" disabled>Select a company</option>
            {allCompanies.map(companyObj => (
                <option key={companyObj.companyId} value={companyObj.company}>
                    {companyObj.company}
                </option>
            ))}
        </select>
        </div>
    );
}
export default AdminDropdown;
